import { render, staticRenderFns } from "./InvoiceControl.vue?vue&type=template&id=05b95ca8&scoped=true"
import script from "./InvoiceControl.vue?vue&type=script&lang=js"
export * from "./InvoiceControl.vue?vue&type=script&lang=js"
import style0 from "./InvoiceControl.vue?vue&type=style&index=0&id=05b95ca8&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05b95ca8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/flexiquote/flexiquote/uniqms-vue-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('05b95ca8')) {
      api.createRecord('05b95ca8', component.options)
    } else {
      api.reload('05b95ca8', component.options)
    }
    module.hot.accept("./InvoiceControl.vue?vue&type=template&id=05b95ca8&scoped=true", function () {
      api.rerender('05b95ca8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/quote/components/InvoiceControl.vue"
export default component.exports